export * from './src/dynamic-form.module';
export * from './src/dynamic';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
